// @ts-nocheck
import Vue from 'vue';
import moment from 'moment';
import globalVariables from "@/global";
import momentTZ from "moment-timezone";
import { formatPriceCalendar } from '@/utils/formatPrice';

Vue.filter('completeUserName', (user) => {
	return ((user.data.firstname ? user.data.firstname : '')
		+ ' '
		+ (user.data.lastname ? user.data.lastname : '')).trim() || user.data.gamename.trim();
});

Vue.filter('shortUserName', (user) => {
	if (user.data.salesgroup_id !== null) {
		return user.data.company_name;
	}
	const name = ((user.data.firstname + ' ' + (user.data.lastname || '').substring(0, 1)).trim() || user.data.gamename).trim();
	if (user.data.lastname) {
		return name + '.';
	}
	return name;
});

Vue.filter('timestampToHumanDate', (ts) => {
	return moment(ts).format('LL LTS');
});

Vue.filter('timestampToDateOnly', (ts) => {
	return moment(ts).format('LL');
});

Vue.filter('tsToFormat', (ts, format, useTenantsTimezone = false) => {
	const momentObj = moment(ts);

	if (useTenantsTimezone) {
		momentObj.tz(globalVariables.vm.$root.websiteConfig.data.tenant.timezone);
	}

	return momentObj.format(format);
});

Vue.filter('currency', (value, currency, locale = globalVariables.vm.$i18n.locale) => {
	let currencyValue = Intl.NumberFormat(locale, { style: 'currency', currency: currency || globalVariables.websiteConfig.data.tenant.currency.code }).format(value);

	if (globalVariables.websiteConfig.data.tenant.currency.code === 'QAR') {
		currencyValue = currencyValue.replace('QAR', '') + ' QAR';
	}

	return currencyValue;
});

Vue.filter('formatPriceWithDecimal', (value, currency, locale = globalVariables.vm.$i18n.locale) => {
    const formattedValue = Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    }).format(value);

    return formattedValue.replace('.', ',');
});

Vue.filter('currencyWithoutCountry', (value, currency, locale = globalVariables.vm.$i18n.locale) => {
	let price =  Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currency || globalVariables.websiteConfig.data.tenant.currency.code,
		currencyDisplay: 'narrowSymbol'
	}).format(value);

	if ((currency ?? globalVariables.websiteConfig.data.tenant.currency.code) === 'USD') {
		price = price.replace('US$', '$')
	}

	return price;
});

export const getCurrencySign = (currency?: string, locale = 'en-US', value = 0 ) => {
	return Intl.NumberFormat(locale, {
		style: 'currency',
		currency: currency || globalVariables.websiteConfig.data.tenant.currency.code
	}).format(value).replaceAll(/[0-9,.]/gi, '');
}

Vue.filter('currencySign', getCurrencySign);

Vue.filter('taxes', (value, locale = 'en-US') => {
	return Intl.NumberFormat(locale, {
		style: "percent",
		maximumFractionDigits: 5,
	}).format(value);
});

Vue.filter('formatPriceCalendar', (value, locale = 'en-US') => {
	const currencyCode = globalVariables.websiteConfig.data.tenant.currency.code;
	return formatPriceCalendar(value, locale, currencyCode);
});

Vue.filter('translatable', (original, json, locale = globalVariables.vm.$i18n.locale) => {
	try {
		const jsonData = typeof json === 'string' ? JSON.parse(json) : JSON.parse(JSON.stringify(json)); // Make a clone to handle VueJs Observer

		if(jsonData !== null) {
			// Override missing translation to fr if no sub fr translation set (fr-ca, fr-fr,...)
			if (locale.includes('fr-') && !jsonData[locale] && jsonData.fr) {
				return jsonData.fr;
			}
			// Override missing translation to en if no sub en translation set (en-ca, en-gb,...)
			if (locale.includes('en-') && !jsonData[locale] && jsonData.en) {
				return jsonData.en;
			}

			// Fallback on an empty string if nothing is set for the current locale, the original or the default locale
			return jsonData[locale] || original || jsonData.en || ""
		}
		return original;
	} catch (error) {
		return original;
	}
});

Vue.filter('dateToTenantTimezone', (date = new Date()) => {
	const now = momentTZ(date);
	const serverOffset = now.utcOffset();
	now.tz(globalVariables.websiteConfig.data.tenant.timezone);

	const localOffset = now.utcOffset();
	const diffInMinutes = serverOffset - localOffset;
	const tenantDate = moment(date);
	tenantDate.add(-diffInMinutes, 'minutes');

	return tenantDate.clone();
})
